// extracted by mini-css-extract-plugin
module.exports = {"blockbutton":"BlockButton_blockbutton__eU_yC","active":"BlockButton_active__mpyFK"};